import { render, staticRenderFns } from "./LegacyTag.vue?vue&type=template&id=6b408542&scoped=true&lang=pug"
import script from "./LegacyTag.vue?vue&type=script&lang=js"
export * from "./LegacyTag.vue?vue&type=script&lang=js"
import style0 from "./LegacyTag.vue?vue&type=style&index=0&id=6b408542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b408542",
  null
  
)

export default component.exports